export const PAGE_SIZE = 25;
export const MOBILE_SCREEN_SIZE = 768;
export const TABLET_SCREEN_SIZE = 1200;

export const FULL_HD_DIMENSION = {
  WIDTH: 1920,
  HEIGHT: 1080
};

export const KEYBOARD_KEYS = {
  ENTER: 'Enter'
};

/**
 * Fallback port for a device that has not reported one of its own. Not a configuration knob:
 * it is the port the player has always shipped with, and the only sensible guess for a device
 * running software older than 2.0.15. Devices that report a port use that instead.
 */
export const DEFAULT_DEVICE_PORT = 5011;

/**
 * Fallback blob URL of the Sentoa Player installer: the production MSI, which is what every CMS
 * environment served before this became configurable. Each environment now sets its own
 * `window.PLAYER_INSTALLER_DOWNLOAD_URL` in config.js, so dev and QA can hand out an installer
 * already pointed at their own backend. Read it through `playerInstallerDownloadUrl()` rather
 * than directly - this constant is only what that falls back to when the key is absent.
 */
export const DEFAULT_PLAYER_INSTALLER_DOWNLOAD_URL =
  'https://sentoapublicstorage.blob.core.windows.net/device/prod/Sentoa-Player-Setup.msi';
